import React, { useEffect } from "react";
import Header from "./HeaderComponent";
import "../assets/css/corporate.css";
import FooterComponent from "./FooterComponent";
import arrow from "../assets/images/blog_post_arrow.svg";


/**
  Shows Annual Returns page
*/
function Corporate() {
    useEffect(() => {
        const scroll_to = document.getElementById("corporate_section");
        if (scroll_to) {
            scroll_to.scrollIntoView({ behavior: "smooth" });
        }
    }, []);
    return (
        <div id="corporate_section">
            <div className="container" >
                <div class="row">
                    <div className="col-md-1 col-sm-2 col-xs-12"></div>
                    <div className="col-md-10 col-sm-8 col-xs-12" id="padding_privacy_id">
                        <div id="corporate_header">
                            <Header />
                        </div>
                        <div id="corporate_container" >
                            <div
                                className="text-center px-2"
                            >
                                <div id="corporate_main_head">Corporate</div>
                                <div id="corporate_intro">
                                    We remain dedicated to transparency and accountability in all our stakeholder interactions. Our corporate documents offer a clear and comprehensive summary of the company’s financial performance, accomplishments, and key milestones over the fiscal year.
                                </div>
                            </div>
                        </div>
                        <div id="corporate_container_intro">
                        <div id="corporate_sub_heads">Annual Returns</div>
                            <div className="text-left">
                            <a href="https://docs.aurm.in/finrpts/2023-2024/mgt-7a.pdf" className="text-decoration-underline">
                                2023-2024 MGT-7A <span className='corporate_arrow_img'><img src={arrow} alt="Arrow" /></span>
                            </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="corporate_footer" id="corporate_footer">
                <FooterComponent />
            </div>
        </div>
    );
}

export default Corporate;
